export const canvasInfoActions = {
    startLoader: "START_UPDATE_CANVAS_INFO_LOADER",
    request: "REQUEST_CANVAS_INFO",
    update: "UPDATE_CANVAS_INFO",
    success: "UPDATE_CANVAS_INFO_SUCESS",
    failure: "UPDATE_CANVAS_INFO_FAILURE",
    reset: "RESET_UPDATE_CANVAS_INFO",
};

export const getCanvasInfo = (buyplanId, month) => {
    return {
        type: canvasInfoActions.request,
        payload: {
            buyplanId,
            month
        },
    };
};

export const updateCanvasInfo = (buyplanId, month, canvasData) => {
    return {
        type: canvasInfoActions.update,
        payload: {
            buyplanId,
            month,
            canvasData
        },
    };
};

export const getCanvasInfoSuccess = (payload) => {
    return {
        type: canvasInfoActions.success,
        payload,
    };
};

export const getCanvasInfoFailure = (errorPayload) => {
    return {
        type: canvasInfoActions.failure,
        payload: errorPayload,
    };
};
